import React, { useState } from "react";
import { markInsufficientInventory } from "./workflow_repo";

interface Props {
  outwardId: string;
  entityLabel: string;
  onClose: () => void;
  onSuccess: () => void;
}

const MarkInsufficientInventoryModal: React.FC<Props> = ({
  outwardId,
  entityLabel,
  onClose,
  onSuccess,
}) => {
  const [remark, setRemark] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async () => {
    const trimmed = remark.trim();
    if (!trimmed) {
      setError("Please enter a remark");
      return;
    }
    setSubmitting(true);
    setError(null);
    const res = await markInsufficientInventory(outwardId, trimmed);
    setSubmitting(false);
    if (res?.success) {
      onSuccess();
      onClose();
    } else {
      setError(res?.error || "Failed to flag insufficient inventory");
    }
  };

  return (
    <div
      id="warehouse-workflow-insufficient-inventory-modal"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 p-4"
    >
      <div className="w-full max-w-md rounded-lg bg-white shadow-lg p-5 wh-modal-xs max-h-[90vh] overflow-y-auto">
        <h3 className="text-base font-semibold text-gray-900">
          Flag insufficient inventory
        </h3>
        <p className="text-xs text-gray-500 mt-1">
          For {entityLabel}. The order status stays at Device Allocation
          Pending; this is logged in the workflow timeline.
        </p>
        <textarea
          id="warehouse-workflow-insufficient-inventory-remark-textarea"
          className="mt-3 w-full h-24 rounded border border-gray-300 px-2 py-1 text-sm focus:outline-none focus:border-blue-500"
          placeholder="e.g. Insufficient stock to fulfill this order; awaiting next inward"
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
          disabled={submitting}
        />
        {error && <div className="text-xs text-red-600 mt-1">{error}</div>}
        <div className="flex justify-end gap-2 mt-4">
          <button
            id="warehouse-workflow-insufficient-inventory-cancel-btn"
            type="button"
            onClick={onClose}
            disabled={submitting}
            className="px-3 py-1.5 rounded border border-gray-300 text-sm text-gray-700 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            id="warehouse-workflow-insufficient-inventory-save-btn"
            type="button"
            onClick={handleSubmit}
            disabled={submitting}
            className="px-3 py-1.5 rounded bg-blue-600 text-white text-sm hover:bg-blue-700 disabled:opacity-50"
          >
            {submitting ? "Saving…" : "Save remark"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MarkInsufficientInventoryModal;
